import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import AppErrorScreen from "./appErrorScreen.jsx";

function getErrorMessage(error) {
  if (isRouteErrorResponse(error)) {
    return error.data?.message || error.statusText || "Something went wrong.";
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "Something went wrong while loading this page.";
}

export default function RouteErrorElement() {
  const error = useRouteError();
  const statusCode = isRouteErrorResponse(error) ? error.status : 500;
  const message = getErrorMessage(error);

  return <AppErrorScreen message={message} statusCode={statusCode} />;
}